export default {
  "b2b.uzivatele-grid-columns.jmeno.label": "Jméno",
  "b2b.uzivatele-grid-columns.telefon.label": "Telefon",
  "b2b.uzivatele-grid-columns.email.label": "E-Mail",
  "b2b.uzivatele-grid-columns.role.label": "Role"
};
